export const BILLING_BLOCK_ERROR_CODES = new Set(['insufficient_balance', 'negative_balance', 'product_not_in_plan', 'usage_limit_exceeded', 'billing_check_failed'])

export interface BillingBlockDetails {
  estimated_cost_cents?: number
  balance_cents?: number
  wallet_cents?: number
  shortfall_cents?: number
  product_slug?: string
  error_code?: string
  reason?: string
  message?: string
  cta_type?: 'add_credits' | 'contact_sales' | 'see_plans' | 'contact_support' | 'none'
  paywall_variant?: string
  [key: string]: any
}

export class StructuredApiError extends Error {
  statusCode: number
  errorCode?: string
  details?: Record<string, any>

  constructor(message: string, statusCode: number, errorCode?: string, details?: Record<string, any>) {
    super(message)
    this.name = 'StructuredApiError'
    this.statusCode = statusCode
    this.errorCode = errorCode
    this.details = details
  }
}

export function normalizeBillingBlockError(error: unknown): BillingBlockDetails | null {
  const candidate = error as {
    message?: string
    errorCode?: string
    details?: Record<string, any>
    response?: {
      status?: number
      data?: {
        error?: string
        message?: string
        error_code?: string
        details?: Record<string, any>
      }
    }
  }

  const responseData = candidate?.response?.data
  const statusCode = (candidate as { statusCode?: number })?.statusCode || candidate?.response?.status
  const errorCode = candidate?.errorCode || responseData?.error_code || candidate?.details?.error_code || (statusCode === 402 ? 'billing_check_failed' : undefined)

  if (!errorCode || !BILLING_BLOCK_ERROR_CODES.has(errorCode)) {
    return null
  }

  const details = candidate?.details || responseData?.details || {}
  const message = candidate?.message || responseData?.message || responseData?.error || details.message

  return {
    ...details,
    error_code: errorCode,
    message,
  }
}
